import React, { useState } from "react";
import DashboardDrawer from './DashboardDrawer';
import CreateNewScheduleStepsCardComponent from './CreateNewScheduleStepsCardComponent'
import InitialDashboardComponent from './InitialDashboardComponent'
import ScheduleContainer from '../school/schedule/ScheduleContainer'
import { MuiGrid, MuiIconButton, MuiTypography, MuiFab, MuiMoreVertIcon, MuiPersonAdd } from "../../ui/MaterialUIComponents";
import lodashUtil from 'lodash';
import spinner from "../../ui/icons/spinner.gif";
import theme from "../../../assests";
import '../../ui/scrollbarForLog.css'
import { Redirect } from 'react-router-dom';
import routes from "../../navigation/Routes"
export default function DashboardComponent(props) {
  const [toAddNewRules, setToAddNewRules] = React.useState(false);
  const toggleToAddNewRules = () => {
  
    setToAddNewRules(true);
  };
  if (toAddNewRules) {
    return <Redirect to={{
      pathname: routes.addNewRules,
      state: {
        activeSchool: props.activeSchool,
        activeScheduleId: props.activeSchool.schedule_constraints[props.activeSchool.schedule_constraints.length - 1]['_id'],
        scheduleIndex: props.activeSchool.schedule_constraints.length - 1,
        stepperIndex: 0,
        disableEdit: false,
        overrideData: false
      }
    }} />
  } else {
    return <MuiGrid style={{ marginTop: 64, }} xs={12}>
      {props.getSchoolInformationByIdInProgress == true ? (
        <img
          src={spinner}
          alt="none"
          style={theme.spinnerImgStyle}
        />
      ) : props.activeSchool != undefined && !lodashUtil.isEmpty(props.activeSchool) ?
          <MuiGrid container direction='row' xs={12}>
            <MuiGrid style={{ backgroundColor: theme.palette.grey.lighter }} xs={12} ><DashboardDrawer {...props} /></MuiGrid>
            <MuiGrid xs={12}> {props.activeSchool.schedule_constraints != undefined && props.activeSchool.schedule_constraints.length > 0 ? <ScheduleContainer {...props} /> : props.activeSchool.school_master.gradeLevels && props.activeSchool.school_master.gradeLevels.length > 0 ? <CreateNewScheduleStepsCardComponent {...props} toggleToAddNewRules={toggleToAddNewRules} /> : ''}</MuiGrid></MuiGrid>
          : <MuiGrid item style={{ overflow: 'hidden'}} xs={12}><InitialDashboardComponent {...props} /></MuiGrid>}
    </MuiGrid>
  }
}